import React from 'react';
import Page from 'components/acommon/Page';

import Main from './Main';

function HomeScreen() {
  return (
    <Page showFooter>
      <Main />
    </Page>
  );
}

export {HomeScreen};
